import { Button } from "primereact/button";

import type { EmbarcacaoDetailExportButtonViewModel } from "./types-embarcacao-detail-export-button";

export function EmbarcacaoDetailExportButtonView({
  label,
  size,
  ariaBusy,
  title,
  disabled,
  onClick,
}: EmbarcacaoDetailExportButtonViewModel) {
  return (
    <Button
      type="button"
      label={label}
      severity="secondary"
      size={size}
      aria-haspopup="dialog"
      aria-busy={ariaBusy}
      title={title}
      disabled={disabled}
      onClick={onClick}
      data-testid="embarcacao-detail-export"
    />
  );
}
